import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ipSharedEmpty',
  standalone: true,
})
export class EmptyPipe implements PipeTransform {
  transform(value: unknown, defaultValue?: string): unknown {
    return value ? value : defaultValue ? defaultValue : '-';
  }
}
